import { Projeto } from './projeto.model';
import { PropriedadeIntelectual } from './propriedade-intelectual.model';

export class ProjetoPropriedadeIntelectual {

  id: number;
  propriedadeIntelectual: PropriedadeIntelectual;
  projeto: Projeto;
  remover: boolean;
  selecionado: boolean;
  unico: boolean;

  constructor(init?: Partial<ProjetoPropriedadeIntelectual>) {
    Object.assign(this, init);
  }
}
